@if (config) {
<div class="c-textblock">
  <div class="c-textblock__wrap">
    <div class="u-text-center">
      <i class="c-textblock__icon" [class]="config.icon"></i>
    </div>
    <div>
      <h2 class="u-h1 u-color-black">
        {{ config.title }}
      </h2>
      <p class="u-mt-2">
        {{ config.subtitle }}
      </p>
    </div>
    <div class="p-flexcc">
      <a class="e-btn--primary" href="/"> Volver a inicio </a>
    </div>
  </div>
</div>
}
